module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Media/Rec-3906db6066698abf62f5862aedb39b9212d788caf4a617dfafdab1858e3d5fa3.svg";